import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { rem } from 'polished'
import { Flex, Box } from 'rebass'
import { getVisibleSections } from '../../utils/router'
import RouterMoreDropDown from '../../components/RouterMoreDropDown'
import RouterBreadCrumb from '../../components/RouterBreadCrumb'
import brandLogoMapper from '../../../lib/make/brand-logo-mapper'
import { Grid } from '../../utils/style'

/*************************
 STYLES: Router
 **************************/
const Wrapper = styled(Flex)`
  position: relative;
  z-index: 3;
  line-height: 1;
  background: white;
  align-items: center;
  height: 100%;
`

const RouterItem = styled(({ full, ...rest }) => <Grid {...rest} />)`
  vertical-align: baseline;
  display: inline-block;
  margin: 10px 5px 0 5px;
  a {
    text-decoration: none;
    text-transform: uppercase;
    font-size: ${rem('14.5px')};
    font-weight: 600;
    letter-spacing: 0.12em;
    color: ${(props) => props.theme.colors.grey_light};
    opacity: 0.6;
    display: block;
    padding: ${(props) =>
      props.full ? '18px 11px 12px 12px' : '10px 11px 12px 12px'};
    margin-bottom: 10px;
    transition: opacity 0.3s ${(props) => props.theme.ease.ease_out_expo},
      color 0.3s ${(props) => props.theme.ease.ease_out_expo};

    &:hover {
      opacity: 1;
    }
  }

  a.active {
    opacity: 1;
    color: ${(props) => props.theme.colors.blue};
    border-bottom: 3px ${(props) => props.theme.colors.blue} solid;
  }
`

/*************************
 STYLES: Brand
 **************************/

const BrandBox = styled(Box)`
  position: relative;
  z-index: 1;
  flex-grow: 1;

  > div > div {
    background: white;
    position: relative;
  }
`

const Aligner = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`

const BrandItem = styled(Grid)`
  margin: 0 5px;
  path {
    transition: fill 0.5s ${(props) => props.theme.ease.ease_out_expo};
  }

  &:hover path {
    fill: ${(props) => props.theme.colors.grey_op65};
  }
`

const NavWrapper = styled(Box)`
  min-width: 60%;
`

class RouterPrimaryExpanded extends React.PureComponent {
  render() {
    const sections = getVisibleSections(this.props.sections, this.props.max)

    return (
      <Wrapper id="target-primary">
        <NavWrapper
          ml={[null, null, '3%', '5.5%']}
          as="nav"
          {...(!this.props.full && { width: [8 / 12] })}
          id="navigation"
        >
          {sections.visible.map((section) => (
            <RouterItem
              full={this.props.full}
              mx={[null, null, '5px', 10]}
              mt={10}
              mb={0}
              key={`section:${section.slug}`}
            >
              <Link
                key={`section:link:${section.slug}`}
                to={`/${section.root ? '' : section.slug}`}
                className="router__visible-link"
                getProps={({ location, isPartiallyCurrent }) => {
                  return (section.label === 'Cars' && this.props.isCars) ||
                    (section.label === 'Vans' && this.props.isVans) ||
                    (section.root
                      ? location.pathname === '/' ||
                        location.pathname.substring(
                          1,
                          section.slug.length + 1
                        ) === section.slug
                      : isPartiallyCurrent)
                    ? { className: 'active' }
                    : null
                }}
              >
                {section.label}
              </Link>
            </RouterItem>
          ))}
          <RouterMoreDropDown sections={sections.more} Link={Link} />
          <RouterBreadCrumb sections={sections.more} Link={Link} />
        </NavWrapper>
        {this.props.brands && (
          <BrandBox width={[4 / 12]} mr={15}>
            <Aligner className="brand_categories">
              {this.props.brands.map((brand) => (
                <BrandItem
                  mx={[null, null, '6px', 15]}
                  key={`brand:${brand.name}:${brand.category}`}
                >
                  <Link to={`/${brand.slug}`} aria-label={brand.name}>
                    {brandLogoMapper(brand) || brand.name}
                  </Link>
                </BrandItem>
              ))}
            </Aligner>
          </BrandBox>
        )}
      </Wrapper>
    )
  }
}

export default RouterPrimaryExpanded
